import React, { useEffect } from 'react';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

export default function SimpleGallery(props) {
  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: '#' + props.galleryID,
      children: 'a',
      pswpModule: () => import('photoswipe'),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
    // Deliberately mount-once: re-running this on every galleryID change would
    // tear down and reinit PhotoSwipe, which isn't what we want here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="pswp-gallery grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-3 xl:gap-x-8" id={props.galleryID}>
      {props.images.map((image, index) => (
        <a
          className='relative'
          href={image.largeURL}
          data-pswp-width={image.width}
          data-pswp-height={image.height}
          key={props.galleryID + '-' + index}
          target="_blank"
          rel="noreferrer"
        >
          <div className='group aspect-w-10 aspect-h-7 block w-fdivl overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 focus-within:ring-offset-gray-100'>
            <img src={image.thumbnailURL} alt="" className='pointer-events-none object-cover group-hover:opacity-75' />
            <button type="button" className="absolute inset-0 focus:outline-hidden">
              <span className="sr-only">View details for image</span>
            </button>
          </div>
        </a>
      ))}
    </div>
  );
}
